import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './NavigationSidebar.css'

const NavigationSidebar = ({ isMobileMenuOpen }) => {
  const location = useLocation()
  const [expandedSections, setExpandedSections] = useState({
    platformCapabilities: true,
    account: true,
    resources: true
  })

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }))
  }

  const isActive = (path) => {
    return location.pathname === path
  }

  return (
    <aside className={`navigation-sidebar ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
      <nav className="sidebar-nav">
        <Link 
          to="/" 
          className={`nav-item ${isActive('/') ? 'active' : ''}`}
        >
          Welcome to Aedify.AI
        </Link>
        
        <Link 
          to="/quick-start" 
          className={`nav-item ${isActive('/quick-start') ? 'active' : ''}`}
        >
          Quick Start
        </Link>

        <div className="nav-section">
          <button 
            className="nav-section-header"
            onClick={() => toggleSection('platformCapabilities')}
          >
            <span>Platform Capabilities</span>
            <svg 
              className={`section-arrow ${expandedSections.platformCapabilities ? 'expanded' : ''}`}
              width="12" 
              height="12" 
              viewBox="0 0 12 12" 
              fill="none"
            >
              <path d="M6 9L1 4L11 4L6 9Z" fill="currentColor"/>
            </svg>
          </button>
          {expandedSections.platformCapabilities && (
            <div className="nav-section-items">
              <Link
                to="/platform-capabilities/apps"
                className={`nav-item nested ${isActive('/platform-capabilities/apps') ? 'active' : ''}`}
              >
                Apps
              </Link>
              <Link
                to="/resources/cli"
                className={`nav-item nested ${isActive('/resources/cli') ? 'active' : ''}`}
              >
                CLI
              </Link>
              <Link
                to="/platform-capabilities/registry" 
                className={`nav-item nested ${isActive('/platform-capabilities/registry') ? 'active' : ''}`}
              >
                Registry
              </Link>
              {/* Cloud Storage - Hidden for now */}
              {/* <Link 
                to="/platform-capabilities/cloud-storage" 
                className={`nav-item nested ${isActive('/platform-capabilities/cloud-storage') ? 'active' : ''}`}
              >
                Cloud Storage
              </Link> */}
              <Link 
                to="/platform-capabilities/database" 
                className={`nav-item nested ${isActive('/platform-capabilities/database') ? 'active' : ''}`}
              >
                Database
              </Link>
              <Link 
                to="/platform-capabilities/vps" 
                className={`nav-item nested ${isActive('/platform-capabilities/vps') ? 'active' : ''}`}
              >
                VPS
              </Link>
            </div>
          )}
        </div>

        <div className="nav-section">
          <button 
            className="nav-section-header"
            onClick={() => toggleSection('account')}
          >
            <span>ACCOUNT</span>
            <svg 
              className={`section-arrow ${expandedSections.account ? 'expanded' : ''}`}
              width="12" 
              height="12" 
              viewBox="0 0 12 12" 
              fill="none"
            >
              <path d="M6 9L1 4L11 4L6 9Z" fill="currentColor"/>
            </svg>
          </button>
          {expandedSections.account && (
            <div className="nav-section-items">
              <Link 
                to="/account/billing" 
                className={`nav-item nested ${isActive('/account/billing') ? 'active' : ''}`}
              >
                Billing
              </Link>
              <Link 
                to="/account/usage" 
                className={`nav-item nested ${isActive('/account/usage') ? 'active' : ''}`}
              >
                Usage
              </Link>
            </div>
          )}
        </div>

        <div className="nav-section">
          <button 
            className="nav-section-header"
            onClick={() => toggleSection('resources')}
          >
            <span>Resources</span>
            <svg 
              className={`section-arrow ${expandedSections.resources ? 'expanded' : ''}`}
              width="12" 
              height="12" 
              viewBox="0 0 12 12" 
              fill="none"
            >
              <path d="M6 9L1 4L11 4L6 9Z" fill="currentColor"/>
            </svg>
          </button>
          {expandedSections.resources && (
            <div className="nav-section-items">
              <Link 
                to="/resources/api-keys" 
                className={`nav-item nested ${isActive('/resources/api-keys') ? 'active' : ''}`}
              >
                API Keys
              </Link>
              <Link
                to="/resources/vscode-extension"
                className={`nav-item nested ${isActive('/resources/vscode-extension') ? 'active' : ''}`}
              >
                VS Code Extension
              </Link>
              <Link 
                to="/resources/faq" 
                className={`nav-item nested ${isActive('/resources/faq') ? 'active' : ''}`}
              >
                FAQ
              </Link>
              <Link 
                to="/resources/support" 
                className={`nav-item nested ${isActive('/resources/support') ? 'active' : ''}`}
              >
                Support
              </Link>
              <Link 
                to="/resources/community" 
                className={`nav-item nested ${isActive('/resources/community') ? 'active' : ''}`}
              >
                Community
              </Link>
            </div>
          )}
        </div>
      </nav>
    </aside>
  )
}

export default NavigationSidebar
